var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightblue01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a7cbf0;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.05,74.72c0,3.51,2.84,6.35,6.35,6.35s6.35-2.84,6.35-6.35-6.35-11.14-6.35-11.14c0,0-6.35,7.63-6.35,11.14Zm5.63,4.09c-2.59,0-3.73-2.2-3.97-3.36l1.33-.28c.02.09.52,2.28,2.64,2.28v1.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.33,53.87v-2.32c0-9.86-8.02-17.89-17.89-17.89h-1.6v-2.96h-5.33v-5.66h8.51v-4.17h-8.51v-1.94h-5.96v1.94h-8.32v4.17h8.32v5.66h-5.33v2.96h-6.27v-4.84h-5.96v24.31h5.96v-5.46h24.49c2.14,0,3.88,1.74,3.88,3.88v2.32h-1.53v5.96h17.22v-5.96h-1.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightblue01);
export default __webpack_public_path__ + "static/media/lightblue01.8711b232c518ad7d03d4f82875a87731.svg";
export { ForwardRef as ReactComponent };